import { render, staticRenderFns } from "./TwoAthletesSoccerBackground.vue?vue&type=template&id=418d6a75&"
import script from "./TwoAthletesSoccerBackground.vue?vue&type=script&lang=js&"
export * from "./TwoAthletesSoccerBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports